import { z } from 'zod'

export const recordingTypedSchema = z.object({
  account_id: z.string({ required_error: 'Account is required' }).uuid('Account is required'),
  label: z
    .string({ required_error: 'Label is required' })
    .min(1, 'Label is required')
    .max(64, 'Label must be 64 characters or less'),
  notes: z.string().max(1024, 'Notes must be 1024 characters or less').nullable().optional(),
  ext_number: z
    .string()
    .max(5, 'Extension number must be 5 digits or less')
    .regex(/^\d*$/, 'Extension number must contain only digits')
    .nullable()
    .optional()
})

export type RecordingFormValues = z.infer<typeof recordingTypedSchema>

export const editRecordingSchema = z.object({
  label: z
    .string({ required_error: 'Label is required' })
    .min(1, 'Label is required')
    .max(64, 'Label must be 64 characters or less'),
  notes: z.string().max(1024, 'Notes must be 1024 characters or less').nullable().optional(),
  ext_number: z
    .string()
    .max(5, 'Extension number must be 5 digits or less')
    .regex(/^\d*$/, 'Extension number must contain only digits')
    .nullable()
    .optional()
})

export type EditRecordingFormValues = z.infer<typeof editRecordingSchema>
